import Api from '@/api'
const resource = 'products'

export default {
  fetchProducts () {
    return Api.get(`/${resource}`)
  }
}
